module.exports = __webpack_public_path__ + "static/img/EmissorReceptorIR-1.1815e46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/EmissorReceptorIR-1.svg
// module id = dINq
// module chunks = 0